define([], () => ({
  REQUEST_SERVICE_CONFIG: 'REQUEST_SERVICE_CONFIG',
  RECEIVE_SERVICE_CONFIG: 'RECEIVE_SERVICE_CONFIG',
  RECEIVE_ADDITIONAL_SERVICE_CONFIG: 'RECEIVE_ADDITIONAL_SERVICE_CONFIG',
  ERROR_SERVICE_CONFIG: 'ERROR_SERVICE_CONFIG',

  REQUEST_CONNECT: 'REQUEST_CONNECT',
  ERROR_CONNECT: 'ERROR_CONNECT',
  DISCONNECT_SERVICE: 'DISCONNECT_SERVICE',

  RECEIVE_FORMSYNC_SETTINGS: 'RECEIVE_FORMSYNC_SETTINGS',
  RECEIVE_EXACTTARGET_FIELDS: 'RECEIVE_EXACTTARGET_FIELDS',

  UPDATE_INTEGRATION_FILTER: 'UPDATE_INTEGRATION_FILTER',

  REQUEST_SERVICE_STATE: 'REQUEST_SERVICE_STATE',
  RECEIVE_SERVICE_STATE: 'RECEIVE_SERVICE_STATE',
  ERROR_SERVICE_STATE: 'ERROR_SERVICE_STATE',

  SAVE_SERVICE_SETTINGS: 'SAVE_SERVICE_SETTINGS',

  UPDATE_INTEGRATION_SETTING: 'UPDATE_INTEGRATION_SETTING',

  REQUEST_SERVICE_SETTINGS: 'REQUEST_SERVICE_SETTINGS',
  RECEIVE_SERVICE_SETTINGS: 'RECEIVE_SERVICE_SETTINGS',
  UPDATE_SERVICE_SETTINGS: 'UPDATE_SERVICE_SETTINGS',
  ERROR_SERVICE_SETTINGS: 'ERROR_SERVICE_SETTINGS',
  REMOVE_SERVICE_SETTINGS: 'REMOVE_SERVICE_SETTINGS',
}));
